"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var constants_1 = require("containers/DesignSystem/constants");
var single_1 = require("utils/selectors/single");
var SidebarGroup_1 = __importDefault(require("./SidebarGroup"));
var SidebarSection_1 = __importDefault(require("./SidebarSection"));
var DesignSystemSidebar = function (_a) {
    var isLocked = _a.isLocked;
    var history = (0, react_router_1.useHistory)();
    var myProfile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    return ((0, jsx_runtime_1.jsx)(SidebarSection_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", py: 2 }, { children: [myProfile.isAdmin && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SidebarGroup_1.default, { categoryLabel: "Design System", menuItems: constants_1.DESIGN_SYSTEM_MENU, isLocked: isLocked }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mr: 1, ml: 2 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { history.push('/'); }, fullWidth: true }, { children: "Back to Dashboard" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { history.push('/settings/my-account'); }, fullWidth: true, sx: { mt: 1 } }, { children: "Back to Settings" }))] }))] })) }));
};
exports.default = DesignSystemSidebar;
